import React from 'react';
import { Grid2 as Grid, type Grid2Props } from '@mui/material';
import { useShowContext } from 'framework/show';
import { getVisibility } from 'framework/utils';
import { GridSpacing } from '@mui/material/Grid/Grid';
import { ResponsiveStyleValue, SxProps } from '@mui/system';

export interface SectionRowProps {
  children: React.ReactElement | React.ReactElement[] | React.ReactNode;
  colMd?: number;
  colXl?: number;
  colXs?: number;
  spacing?: ResponsiveStyleValue<GridSpacing>;
  containerProps?: Grid2Props;
  sxItem?: SxProps;
}

const SectionRow = ({
  children,
  colXs = 12,
  colMd = 4,
  colXl = 3,
  sxItem,
  spacing,
  containerProps,
}: SectionRowProps) => {
  const { data } = useShowContext();

  return (
    <Grid container spacing={spacing || { xs: 2, md: 4 }} sx={{ marginTop: '0 !important' }} {...containerProps}>
      {React.Children.map(children, (child: any) => {
        return child && getVisibility(data, child && child.props && child.props.isVisible) ? (
          <Grid
            sx={{
              mb: 3,
              '& .list-general': {
                mt: -2,
                mb: 1,
              },
              ...sxItem,
            }}
            size={{ xs: colXs, sm: colMd, xl: colXl }}
          >
            {child}
          </Grid>
        ) : null;
      })}
    </Grid>
  );
};

export default SectionRow;
